var _module_exports = "\n<div ng-show=\"item && (!item.additionalInfo || !item.additionalInfo.isPublic)\" class=\"tb-uppercase\">{{ item | contactShort }}</div>";;
var path = '/customer/customer-card.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;